import { UseQueryResult, useQuery } from "react-query";
import { getDraftByIdResponse, useQueryApiError } from "../types";
import { useUser } from "./useUser";
import { getDraftsByIdService } from "../services/getDraftByIdService";
import { DraftConsentConfigType } from "../types/newVersionConsentConfig";

type useDraftByIdByIdHookType = {
  draftByIdQuery: UseQueryResult<getDraftByIdResponse, useQueryApiError>;
  dataFetched?: DraftConsentConfigType;
  isLoading: boolean;
  isError: boolean;
  error: useQueryApiError | null;
};

type Params = {
  draftId: string;
};

export const useDraftById = ({ draftId }: Params): useDraftByIdByIdHookType => {
  const { user } = useUser();

  const draftByIdQuery = useQuery<getDraftByIdResponse, useQueryApiError>(
    ["getDraftById", draftId],
    async () => {
      const response = await getDraftsByIdService({
        draftId,
        token: user.token
      });

      return response;
    },
    { cacheTime: 5000 }
  );

  return {
    draftByIdQuery,
    dataFetched: draftByIdQuery.data?.data,
    isError: draftByIdQuery.isError,
    isLoading: draftByIdQuery.isLoading,
    error: draftByIdQuery.error
  };
};
